import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslatePipe } from './pipes/translate.pipe';//para las traducciones

//Rutas
import{ APP_ROUTING } from './app.routes';

//Servicios
import{ MembershipsService } from './services/memberships.service';
import{ PaymentsService } from './services/payments.service';


//Componentes
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { TermsComponent } from './components/terms/terms.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { LanguageComponent } from './components/language/language.component';
import { PlayerComponent } from './components/player/player.component';
import { TutorialComponent } from './components/tutorial/tutorial.component';
import { Player2Component } from './components/player2/player2.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SuccessComponent } from './components/success/success.component';
import { FailureComponent } from './components/failure/failure.component';
import { AuthInterceptorService } from './services/interceptor.services';
import { TestPlayerComponent } from './components/test-player/test-player.component';
import { PlayerappComponent } from './components/playerapp/playerapp.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { FaqComponent } from './components/faq/faq.component';
import { BoxscoreComponent } from './components/widgets/boxscore/boxscore.component';
import { ScoreboardComponent } from './components/widgets/scoreboard/scoreboard.component';
import { AppLandingComponent } from './components/app-landing/app-landing.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    TermsComponent,
    PrivacyComponent,
    LanguageComponent,
    PlayerComponent,
    TutorialComponent,
    Player2Component,
    CheckoutComponent,
    ProfileComponent,
    SuccessComponent,
    FailureComponent,
    TestPlayerComponent,
    PlayerappComponent,
    CalendarComponent,
    TranslatePipe,
    FaqComponent,
    BoxscoreComponent,
    ScoreboardComponent,
    AppLandingComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    APP_ROUTING
  ],
  providers: [MembershipsService,PaymentsService,{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }